import { useState, useEffect } from "react"

// Components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import { Loading } from "shared/components/ui/Loading"
import InfoIcon from "components/InfoIcon"

// Utils
import { embedDashboard } from "@superset-ui/embedded-sdk"

// Redux
import { useSelector } from "react-redux"
import { useLazyGetSSTokenQuery } from "shared/redux/endpoints/my-impact"

export const TooltipIconColor = {
  BLUE: "blue",
  WHITE: "white",
}

export const TooltipType = {
  CARD: "card",
  TYPE_1: "type1",
  TYPE_2: "type2",
  TYPE_3: "type3",
}

const MyImpact = () => {
  const user = useSelector((state) => state.auth.user)
  const [isLoading, setIsLoading] = useState(true)
  const [errorMessage, setErrorMessage] = useState(null) // State để lưu thông báo lỗi
  const { userId } = user

  const [triggerGetSSToken] = useLazyGetSSTokenQuery()

  const fetchGuestToken = async (userId, token) => {
    try {
      const body = {
        user: {
          username: "embedded",
          first_name: "embedded",
          last_name: "embedded",
        },
        resources: [
          {
            type: "dashboard",
            id: "a82ca3cd-9958-44b1-b4d9-3151d9a20b66",
          },
        ],
        rls: [
          {
            clause: `hubid = ${userId}`,
          },
        ],
      }
      const response = await fetch(
        `${process.env.REACT_APP_MY_IMPACT}/api/v1/security/guest_token/`,
        {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      if (!response.ok) {
        throw new Error(`Failed to fetch guest token: ${response.statusText}`)
      }
      const jsonResponse = await response.json()
      return jsonResponse?.token
    } catch (error) {
      console.error("Error fetching guest token:", error.message)
      //throw error;
    }
  }

  const initEmbedDashboard = async (userId, ssToken) => {
    try {
      const $myImpact = document.getElementById("my-impact")
      const $container = document.getElementById("sen-superset-container")

      if (!$myImpact || !$container) {
        throw new Error("DOM elements for dashboard embedding not found")
      }

      $myImpact.children[0].style.display = "none"

      await embedDashboard({
        id: `${process.env.REACT_APP_MY_IMPACT_DASHBOARD_ID}`,
        supersetDomain: `${process.env.REACT_APP_MY_IMPACT}`,
        mountPoint: $container,
        fetchGuestToken: () => fetchGuestToken(userId, ssToken),

        dashboardUiConfig: {
          hideTitle: false,
          hideChartControls: true,
          hideTab: true,
          filters: {
            visible: false,      // Ẩn  filter panel
            expanded: false,
            //pre filter theo userid
            //native: `NATIVE_FILTER-pv6FM3zAf:(__cache:(label:'${userId}',validateStatus:!f,value:!(${userId})),extraFormData:(filters:!((col:hubid,op:IN,val:!(${userId})))),filterState:(label:'${userId}',validateStatus:!f,value:!(${userId})),id:NATIVE_FILTER-pv6FM3zAf,ownState:(coltypeMap:(hubid:0)))`
          }
        }
      }).then(() => {
        $container.children[0].style.width = "100%"
        $container.children[0].style.height = "100vh"
        $container.children[0].style.border = "none"

        $myImpact.children[0].style.display = "block"
      })
    } catch (error) {
      console.error("Error initializing dashboard:", error.message)
      setErrorMessage("Failed to load dashboard. Please try again later.")
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (userId) {
      triggerGetSSToken()
        .unwrap()
        .then((data) => {
          const ssToken = data
          if (ssToken) {
            initEmbedDashboard(userId, ssToken)
          } else {
            setErrorMessage("Failed to load dashboard. Please try again later.")
            setIsLoading(false)
          }
        })
        .catch((error) => {
          console.error("Error fetching ssToken:", error.message || error)
          setErrorMessage("Failed to load dashboard. Please try again later.")
          setIsLoading(false)
        })
    } else {
      setErrorMessage("User ID not found. Please log in again.")
      setIsLoading(false)
    }
  }, [userId])

  return (
    <DashboardLayout>
      {isLoading && <Loading style={{ height: 200, margin: "10% auto" }} />}
      {errorMessage && (
        <div
          style={{
            textAlign: "center",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "70vh",
            cursor: "default",
            "& @media (max-width: 767px)": {
              padding: "0 30px",
            },
          }}
        >
          {errorMessage}
        </div>
      )}
      <div
        id="my-impact"
        style={{
          padding: "0 20px",
          width: "100%",
          position: "relative",
          opacity: isLoading || errorMessage ? 0 : 1,
        }}
      >
        <div>
          <InfoIcon
            type={TooltipType.TYPE_3}
            color={TooltipIconColor.BLUE}
            content="View key center metrics and track your personal performance."
            style={{
              background: "white",
              fontWeight: "bold",
              display: "flex",
              width: "80%",
              position: "absolute",
              top: "0",
              left: "40px",
              gap: "5px",
              height: "64px",
              zIndex: 100,
              alignItems: "center",
              paddingLeft: "15px",
            }}
          >
            <span>My Impact</span>
          </InfoIcon>

          <div
            id="sen-superset-container"
            style={{ width: "100%", height: "100%", padding: "0 20px" }}
          />
        </div>
      </div>
    </DashboardLayout>
  )
}

export default MyImpact
